'use strict';

import angular from 'angular';
import EditController from './edit.controller';

export default angular.module('updateServerApp.betausers.edit', [])
  .controller('BetaUsersEditController', EditController)
  .name;



// WEBPACK FOOTER //
// ./client/app/betausers/edit/index.js